export default function quote(state = null, action) {
  switch (action.type) {
    case 'FETCH_QUOTE_SUCCESS':
      return action.response
    default:
      return state
  }
}
